import React from 'react';

import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';

const ChunkyButton: React.FC<{
  backgroundColor: string;
  startIcon?: React.ReactNode;
  children: React.ReactNode;
  onClick?: () => void;
  to?: string;
}> = ({ backgroundColor, startIcon, children, onClick, to }) => (
  <Button
    variant="contained"
    startIcon={startIcon}
    onClick={onClick}
    component={to ? Link : 'button'}
    to={to}
    sx={theme => ({
      backgroundColor: backgroundColor,
      color: theme.palette.common.black,
      padding: '8px 16px',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: backgroundColor,
        opacity: 0.85,
      },
    })}
  >
    {children}
  </Button>
);
export default ChunkyButton;
